import React from 'react'
import { Button, Popup, Confirm, Modal } from 'semantic-ui-react'
import fixModalStyle from '../utils/fixModalStyle'

export default class EditQuestionActions extends React.Component {
    state = { questionToDelete: null }

    handleEditClick = () => this.props.onEditClick(this.props.question)
    handleDeleteClick = () => this.setState({ questionToDelete: this.props.question })
    handleCancelDelete = () => this.setState({ questionToDelete: null })
    handleConfirmDelete = () => {
        const { question, onDeleteClick } = this.props
        onDeleteClick(question)
        this.setState({ questionToDelete: null })
    }

    render() {
        const { question, onEditClick, onDeleteClick, ...rest } = this.props

        return (<Button.Group {...rest}>
            {this.state.questionToDelete ? 
                <Confirm open style={fixModalStyle}
                    content={<Modal.Content>Sei sicuro di voler cancellare <b>{question.text}</b>?</Modal.Content>}
                    onCancel={this.handleCancelDelete}
                    onConfirm={this.handleConfirmDelete} /> :
                    ''}
            <Popup trigger={<Button icon='edit' onClick={this.handleEditClick} />} content='Modifica' />
            <Popup trigger={<Button icon='trash' onClick={this.handleDeleteClick} />} content='Elimina' />
        </Button.Group>)
    }
}


// WEBPACK FOOTER //
// ./src/components/EditQuestionActions.js